function fireTaboolaPageView() {
  const id = this.getOcodeValue('component.PartialPageViewPixel.taboolaPixelId');
  const containerId = `tb_tfa_script_${id}`;
  this.win._tfa = this.win._tfa || [];
  this.win._tfa.push({ notify: 'event', name: 'page_view', id });

  if (!this.doc.getElementById(containerId)) {
    const taboolaScript = this.doc.createElement('script');
    taboolaScript.async = 1;
    taboolaScript.src = `//cdn.taboola.com/libtrc/unip/${id}/tfa.js`;
    taboolaScript.id = containerId;
    this.doc.head.appendChild(taboolaScript);
  }
}

function fireTaboolaConversion() {
  const overridePrefix = this.getOverridePrefix();
  const id = this.getOcodeValue(`${overridePrefix}.taboolaPixelId`);
  const eventName = this.getOcodeValue(`${overridePrefix}.taboolaPixelEventName`) || 'CS_ClickOut_Yahoo';

  const container = this.doc.getElementById(`tb_tfa_script_${id}`);
  if (!container) this.fireTaboolaPageView(id);
  this.win._tfa.push({ notify: 'event', name: eventName, id });
}

module.exports = {
  fireTaboolaConversion,
  fireTaboolaPageView
};
